import {createStore, combineReducers} from 'redux';
import ApiReducer from './components/api/ApiReducer.js';

const store = createStore(
	combineReducers({
		api: ApiReducer
	})
);

export default store;